import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Select } from 'redpoints-front-components/index';

import {
  allIncidentsFiltersFetchNonEnforcementReasons,
  allIncidentsFiltersSetReasonCodes,
} from '../../../actions/allIncidentsActions';
import {
  getAllIncidentsFiltersNonEnforcementReasonNormalizedNamesFromSelectedCodes,
  getAllIncidentsFiltersNonEnforcementReasonsGroupedByName,
} from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';
import { getNonEnforcementReasonsCodesFromNormalizedNames } from './formDataHelpers';

const AllIncidentsFiltersNonEnforcementReasons = ({
  allIncidentsFiltersSetReasonCodes,
  groupedReasons,
  selectedNormalizedNames,
}) => {
  const handleChange = newNormalizedNames => {
    const reasonCode = getNonEnforcementReasonsCodesFromNormalizedNames(
      newNormalizedNames,
      groupedReasons
    );
    allIncidentsFiltersSetReasonCodes({
      reasonCode,
    });
  };

  return (
    <div>
      <Select
        allowClear
        data={Object.values(groupedReasons)}
        label={translate(
          'reporting.allIncidentsInternal.filters.nonEnforcementReason'
        )}
        mapping={{ key: 'name', value: 'name' }}
        mode="multiple"
        onChange={handleChange}
        placeholder={translate('common.all')}
        showSearch
        value={selectedNormalizedNames}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  groupedReasons: getAllIncidentsFiltersNonEnforcementReasonsGroupedByName(
    state
  ),
  selectedNormalizedNames: getAllIncidentsFiltersNonEnforcementReasonNormalizedNamesFromSelectedCodes(
    state
  ),
});

export default compose(
  connect(mapStateToProps, {
    allIncidentsFiltersFetchNonEnforcementReasons,
    allIncidentsFiltersSetReasonCodes,
  })
)(AllIncidentsFiltersNonEnforcementReasons);
